import React from 'react';
import { INTERACTIVE_ANALYTICS_DISCOVERY } from '../../../../content/enterpriseMessaging';
import { DiscoveryPipelineVisual } from './InteractiveAnalyticsVisuals';
import SectionSurface from '../../shared/SectionSurface';

const DISCOVERY_BADGE_CLASSES = ['badge-brand', 'badge-semantic', 'badge-migration', 'badge-enterprise'];

export default function DiscoverySection() {
  const copy = INTERACTIVE_ANALYTICS_DISCOVERY;

  return (
    <SectionSurface
      as="section"
      id="semantic-discovery"
      variant="default"
      decor="none"
      bleed="none"
      className="bg-[linear-gradient(135deg,#111827_0%,#243047_55%,#0f172a_100%)]"
    >
      <div className="container-x py-6 sm:py-8">
        <div className="mx-auto max-w-6xl rounded-[28px] bg-white/95 p-6 shadow-[0_24px_70px_rgba(15,23,42,0.22)] ring-1 ring-white/20 sm:p-8 lg:p-10">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12 lg:items-center">
            <div>
              <div className="mb-4 h-1.5 w-16 rounded-full bg-gradient-to-r from-brand-500 to-accent-400" />
              <p className="eyebrow">{copy.eyebrow}</p>
              <h2 className="mt-3 max-w-2xl text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
                {copy.title}
              </h2>
              <p className="mt-4 text-sm font-medium leading-6 text-ink-700">{copy.lead}</p>
              <p className="mt-3 text-sm leading-6 text-ink-600">{copy.body}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {copy.badges.map((b, i) => (
                  <span key={b} className={DISCOVERY_BADGE_CLASSES[i % DISCOVERY_BADGE_CLASSES.length]}>
                    {b}
                  </span>
                ))}
              </div>
            </div>

            <DiscoveryPipelineVisual columns={copy.columns} flowLabel={copy.flowLabel} />
          </div>
        </div>
      </div>
    </SectionSurface>
  );
}
